import React, { Component } from 'react';
import { Container } from 'reactstrap';
//import { NavMenu } from './NavMenu';
import { SideNav } from './SideNav';
import { Footer } from './Footer';
import { Ribbon } from './shared/Ribbon';

export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        const showRibbon = process.env.REACT_APP_ENV !== 'Production';

        return (
            <div>
                {/*<NavMenu />*/}
                <Container fluid className="d-flex flex-column min-vh-100">
                    <div className="row flex-grow-1">
                        <SideNav />
                        {/*<div className="col-md-7 ms-sm-auto col-lg-8 px-md-4 mt-5">*/}
                        <div className="col-md-9 col-lg-10 px-md-4 mt-5">
                            {this.props.children}
                            <Footer />
                        </div>
                    </div >
                </Container>
                {showRibbon && <Ribbon />}
            </div>
        );
    }
}